/**
 * Server errorCode → i18n key defaults shared by the add/edit email modals.
 *
 * OP-7457: OPHUB's B2C validator refuses blocked-TLD addresses (user@gmail.test) with the
 * `CommunicationChannel.Email.Invalid` errorCode (R70). The mapped key reuses the SAME
 * `validation.emailInvalid` message the client-side check renders, derived from the field i18n
 * prefix each consumer already injects — so every consumer of the shared modals gets the explicit
 * email-validation message without hand-copying the map.
 *
 * OP-7542 made `isValidEmail` refuse those TLDs client-side, so the modals now block Save and
 * render that message under the field before any request leaves. This map is the SAFETY NET
 * behind it: a TLD added to the backend list ahead of the FE mirror still lands on the explicit
 * message instead of the generic server-error banner.
 */
export const EMAIL_CHANNEL_INVALID_CODE = "CommunicationChannel.Email.Invalid";
/**
 * Builds the effective errorCode → i18n key map for an email modal.
 *
 * @param fieldI18nPrefix - the prefix holding the field labels (`<prefix>.validation.emailInvalid`
 *   must exist — it is the key the client-side isValidEmail path already renders).
 * @param overrides - consumer-specific map; wins over the built-in defaults on conflict.
 */
export function buildEmailErrorOverrides(fieldI18nPrefix, overrides = {}) {
    return {
        [EMAIL_CHANNEL_INVALID_CODE]: `${fieldI18nPrefix}.validation.emailInvalid`,
        ...overrides,
    };
}
